import { __awaiter, __generator } from "tslib";
import { OfficeRouteItemType, } from '@office-start/officehome-types';
import { getUIHostParams } from '../utilities/getUIHostParams';
import { launchUrl } from './launchUrl';
import { logClick } from './logClick';
export function launchUrlWithDocument(document, context, launchInstrumentationParams, fluidHostFile, useDeeplinkUrl) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var additionalParams, routeUrl, linkTarget, action, result, error_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    additionalParams = {};
                    if (!context.router.getUrlForRoute) {
                        return [2 /*return*/, { success: false, message: 'getUrlForRoute is undefined' }];
                    }
                    if (fluidHostFile) {
                        additionalParams.siteUrl = (_a = document.sharepointIds) === null || _a === void 0 ? void 0 : _a.siteUrl;
                    }
                    if (useDeeplinkUrl && document.navId) {
                        additionalParams.nav = document.navId;
                    }
                    routeUrl = context.router.getUrlForRoute({
                        route: 'Content',
                        type: OfficeRouteItemType.Base,
                        app: document.fileType,
                    }, getUIHostParams(document, additionalParams));
                    if (!routeUrl) return [3 /*break*/, 4];
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    linkTarget = '_blank';
                    action = 'OpenDocument';
                    return [4 /*yield*/, launchUrl(routeUrl, { action: action, linkTarget: linkTarget })];
                case 2:
                    result = _c.sent();
                    logClick({
                        launchInstrumentationParams: launchInstrumentationParams,
                        success: result.success,
                        platform: 'Web',
                    });
                    return [2 /*return*/, result];
                case 3:
                    error_1 = _c.sent();
                    logClick({ launchInstrumentationParams: launchInstrumentationParams, success: false });
                    return [2 /*return*/, {
                            success: false,
                            message: error_1 instanceof Error
                                ? (_b = error_1.stack) !== null && _b !== void 0 ? _b : error_1.message
                                : undefined,
                        }];
                case 4: return [2 /*return*/, { success: false, message: 'launchUrlWithDocument:fallthrough' }];
            }
        });
    });
}
//# sourceMappingURL=launchUrlWithDocument.js.map